import React, { Suspense } from 'react';
import '../../assets/styles/global.css';
import { Switch, Route, Redirect } from 'react-router-dom';
import Login from '../Login';
import LogoutHandler from '../LogoutHandler';
import ProtectedHandler from './ProtectedHandler';
import { SMCPaths, getHelpURL, helpContextPageUrl } from '../../conf/Routes';
import ReloginHandler from '../ReloginHandler';
import SMCPageLoading from '../../components/core/pageComponents/SMCPageLoading';

function App() {
	// Session router handler
    return (
		<Suspense fallback={<SMCPageLoading />}>
			<Switch>
				<Redirect path="/help" to={getHelpURL(helpContextPageUrl.general)} />
				<Route path={SMCPaths.login} component={Login} />
				<Route path={SMCPaths.logout} component={LogoutHandler} />
				<Route path={SMCPaths.relogin} component={ReloginHandler} />
				<Route path="*" component={ProtectedHandler} />
			</Switch>
		</Suspense>
    );
}

export default App;